export function saveHref() {
  const href = window.location.href;
  sessionStorage.setItem("href-before-assuming", href);
}

export function getSavedHref() {
  return sessionStorage.getItem("href-before-assuming");
}
